module.exports = __webpack_public_path__ + "img/vision.22698a83.png";